import {SavedSearch, SavedSearchCreate, SavedSearchResults, SavedSearchUpdate} from "../schemas";
import {apiFetch} from "./client";

export async function getSavedSearches(groupId: string, mineOnly: boolean = false): Promise<SavedSearch[]> {
    const resp = await apiFetch<SavedSearchResults>("/saved_searches/get_by_group", {
        params: {group_id: groupId, mine_only: mineOnly},
    });
    return resp.saved_searches;
}

export async function createSavedSearch(data: SavedSearchCreate): Promise<SavedSearch> {
    return apiFetch<SavedSearch>("/saved_searches/create", {method: "POST", body: data});
}

export async function updateSavedSearch(data: SavedSearchUpdate): Promise<SavedSearch> {
    return apiFetch<SavedSearch>("/saved_searches/update", {method: "POST", body: data});
}

export async function deleteSavedSearch(id: string): Promise<SavedSearch> {
    return apiFetch<SavedSearch>(`/saved_searches/${id}`, {method: "DELETE"});
}
